import { lineNamesFromLine } from './line'

const lineNameFromTicketsHop = (response, hop) => {
  const line = response.lines[hop.line]
  return lineNamesFromLine(line)
}

const vehicleFromTicketsHop = (response, hop) => {
  return response.vehicles[hop.vehicle]
}

const stopsForTicketsHop = (response, hop) => {
  const result = []
  const line = response.lines[hop.line]
  for (const placeIndex of line.places) {
    const place = response.places[placeIndex]
    result.push(place.name)
  }
  return result.slice(1, result.length - 1)
}

export {
  lineNameFromTicketsHop,
  vehicleFromTicketsHop,
  stopsForTicketsHop,
}
